// extracted by mini-css-extract-plugin
module.exports = {"instagramWrap":"HomeInstagram_instagramWrap__nl1HT"};